import React from 'react';
import { useTranslation } from 'react-i18next';
import { classnames } from '../../../../utils/classnames';
import BackButton from '../backButton/backButton';
import LanguageSelector from '../../ui/language/languageSelector';
import './stepHeader.css';
import LogoutButton from '../logout-button/logoutButton';


export default function StepHeader({config = {}, changeLanguage = () => {}, onSubmit = () => {}, isSubmitting, lang, storage, ...rest}) {
    const { t } = useTranslation();
    const _config = config.step_header;
    const logoutTitle = React.useMemo(() => {
        return _config.logout_button?.title || t('widget.header.disconnect');
    }, [config]);

    return (
        <div className={classnames('neo-rate-step-title', {'with-button': _config.previous_button})}>
            {_config.previous_button && <BackButton title={_config.previous_button.title} onSubmit={onSubmit} {...rest}/>}
            <div className='neo-step-header-language-and-disconnect'>
                {_config.available_languages?.length > 0 && (
                    <LanguageSelector
                        loading={isSubmitting}
                        onChange={(lang) => {
                            changeLanguage(null, { value: lang });
                            //TODO: forceLang because stepManager doesn't have time to update the lang before onSubmit is played
                            onSubmit({ forceLang: lang, data: { action: 'change_language' } });
                        }}
                        forceMobile={true}
                        displayIcon={false}
                        value={lang}
                        languages={_config.available_languages}
                    />
                )}
                {_config.logout_button &&
                    <LogoutButton icon={_config.logout_button.icon} type='secondary' contextLogout='stepHeader' title={logoutTitle} storage={storage}/>
                }
            </div>
        </div>
    )
}
